import { useEffect } from 'react';
import { useAuthStore } from './store/auth';
import { LoginPage } from './components/LoginPage';
import { V2App } from './views/v2/V2App';

/** Valuator: sign in, then the app. */
export default function App() {
  const token = useAuthStore((s) => s.token);
  const validateSession = useAuthStore((s) => s.validateSession);

  useEffect(() => {
    validateSession();
  }, [validateSession]);

  if (!token) return <LoginPage />;
  return <V2App />;
}
